import { X } from 'lucide-react'
import { cn } from '@/utils/cn'
import { useUIStore } from '@/stores/ui.store'

const variantMap = {
  success: 'bg-success/10 border-success/30 text-success',
  error: 'bg-error/10 border-error/30 text-error',
  warning: 'bg-warning/10 border-warning/30 text-warning',
  info: 'bg-info/10 border-info/30 text-info',
}

export function NotificationList() {
  const { notifications, removeNotification } = useUIStore()

  if (notifications.length === 0) return null

  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2 max-w-sm w-full pointer-events-none">
      {notifications.map((n) => (
        <div
          key={n.id}
          className={cn(
            'flex items-start gap-3 p-3 rounded-lg border shadow-dropdown animate-slide-in-up pointer-events-auto',
            variantMap[n.tip]
          )}
        >
          <div className="flex-1 min-w-0">
            {n.baslik && <p className="text-sm font-semibold">{n.baslik}</p>}
            <p className="text-sm">{n.mesaj}</p>
          </div>
          <button
            onClick={() => removeNotification(n.id)}
            className="shrink-0 opacity-70 hover:opacity-100 transition-opacity"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  )
}
